import { render, staticRenderFns } from "./ProviderConnections.vue?vue&type=template&id=d50ba8ac&"
import script from "./ProviderConnections.vue?vue&type=script&lang=ts&"
export * from "./ProviderConnections.vue?vue&type=script&lang=ts&"
import style0 from "./ProviderConnections.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports